module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    staticClass: "map-image"
  }, _vm._l((_vm.currentFloorZoomLevels), function(floorZoomLevel) {
    return _c('image', {
      key: floorZoomLevel.level,
      style: (_vm.mapImageOpacity(floorZoomLevel.level)),
      attrs: {
        "x": _vm.x,
        "y": _vm.y,
        "width": _vm.width,
        "height": _vm.height,
        "xlink:href": floorZoomLevel.image
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42d5e1f5","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/map_image.vue
// module id = 866
// module chunks = 0